import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Col, Row } from 'antd'
import { Customer as CustComps, HealthCoach } from '../../component'
import '../../css/customer.scss'
import { useHistory, useParams } from 'react-router'
import { fetchCompany } from '../../store/action/company.action'
import util from '../../util/util'
import { constants } from '../../constants'

const { ActionBar, Table } = CustComps

const HCCTable = HealthCoach.Table

const Customers = (props) => {
  const [company, setCompany] = useState(undefined)
  const params = useParams()
  const history = useHistory()

  useEffect(() => {
    if (
      params?.companyid &&
      props.token?.role?.toString() == constants.ROLE.SUPER_ADMIN
    )
      props
        .fetchCompany(params?.companyid)
        .then((response) => setCompany(response))
  }, [])

  const checkForCompany = () => {
    if (!(props.token?.role?.toString() == constants.ROLE.SUPER_ADMIN)) return
    if (params.companyid) return
    else history.push('/companies')
  }

  return (
    <>
      {checkForCompany()}
      <Row className='customersRow'>
        <Col flex={'auto'}>
          <ActionBar
            disabledAdd={
              props.token?.role?.toString() == constants.ROLE.COMPANY_ADMIN
                ? false
                : true
            }
          />
          {/* { (props.token?.role?.toString() == constants.ROLE.COMPANY_ADMIN)&& <Table companyid={company?._id}/>} */}
          {/* { (props.token?.role?.toString() == constants.ROLE.COMPANY_HEALTHCOACH)&&  <HCCTable companyid={company?._id} />} */}
          <HCCTable companyid={company?._id} />
        </Col>
      </Row>
    </>
  )
}

Customers.propTypes = {}

const mapStateToProps = (state) => {
  return {
    token: util.verifyToken(state.profile.token, true),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchCompany: (companyid) => dispatch(fetchCompany(companyid)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Customers)
